<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Quotation Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    // Loader,
  },
  data() {
    return {
      title: "Quotation Details",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Quotations",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",

      id: atob(this.$route.params.id),      
      data: {
        quotation_id: atob(this.$route.params.id),
        product: "",
        unit: "",
        quantity: "",
        unit_price: "",        
      },
      edit:{
        quotation_id: atob(this.$route.params.id),
        id:"",
        product:"",
        name:"",
        quantity:"",
        price:"",
      },
      deletestock:{
        quotation_id: atob(this.$route.params.id),
        id:"",
        name:"",
      },

      existingItem: [],
      unitsArr: [],

      qtyError: "",
      unitPriceError: "",
      EditqtyError:"",
      PaymentError:"",
      itemError: "",
      quantityError: "",
      unitError: "",
      unit_priceError:"",
      EditpriceError:"",      
    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("quotations", ["Quotation","SaveStatus"]),
    ...mapGetters("sales", ["Products"]),
    ...mapGetters("auth", ["MyUserPerm"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Quotation ? this.Quotation.length : 1;
    },    

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Quotation ? this.Quotation.length : 1;
  },
  updated() {
    
  },

  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
            this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    }
  },
 
  methods: {
    ...mapActions({
      FetchQuotation: "quotations/fetchQuotation",
      AddQuotationProduct: "quotations/addQuotationItem",
      FetchItems: "sales/fetchItems",
      Edit: "quotations/editQuotationItem",
      Delete: "quotations/deleteQuotationItem",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFiltered1(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows1 = filteredItems.length;
      this.currentPage1 = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    redirect(value) {
      this.$router.push(`/printquotation/${btoa(value)}`);
    },
    resetEditModal() {
      this.edit.id = "";
      this.edit.product = "";
      this.edit.name = "";
      this.edit.quantity = "";
      this.edit.price = "";
    },
    resetDeleteModal(){
      this.delete.id = "";
      this.delete.name = "";
    },
    resetData() {
      this.data.product = "";
      this.data.unit = "";
      this.data.quantity = "";
      this.data.unit_price = "";
    },
    resetError(){
        this.qtyError = "";
        this.EditqtyError = "";
        this.EditpriceError = "";
        this.unitPriceError = "";
        this.itemError = "";
        this.unitError = "";
        this.quantityError = "";
        this.unit_priceError = "";
    },
    ShowEdit(data) {
        this.edit.id = data.id;
        this.edit.quantity = parseInt(data.qty);
        this.edit.price = data.price;
        this.edit.name = data.product;
    },
    ShowDelete(data) {
        this.deletestock.id = data.id;
        this.deletestock.name = data.product;
    },

    checkItem() {
      if (this.data.product != "") {
        this.existingItem = this.Quotation.all.filter((item) => {
          return item.product_id == this.data.product;
        });
        if (this.existingItem.length) {
          this.itemError = "This Item exists already";
        } else {
          this.itemError = "";
        }
      } else {
        this.existingItem = [];
      }
    },

    assignArr(){
        let selectedPdt = this.Products.filter((product)=>{
            return product.id == this.data.product;
        });
        this.unitsArr = selectedPdt[0].units;
        this.data.unit = this.unitsArr[0].id;
        this.data.unit_price = this.thousandSeperator(selectedPdt[0].stock.buying_price); 
    },

    assignUnitPrices(){
        let selectedUnit = this.unitsArr.filter((unit)=>{
            return unit.id == this.data.unit;
        });
        let selectedPdt = this.Products.filter((product)=>{
            return product.id == this.data.product;
        });      
        this.data.unit_price = this.thousandSeperator(selectedPdt[0].stock.buying_price*selectedUnit[0].base_qty);
    },

    EditStock(modalId){
      this.modal_id = modalId;
      if(this.edit.quantity==""){
          this.EditqtyError = "Quantity Field is required";
          return
      }
      else{
          this.EditqtyError = "";
      }
      if(this.edit.price==""){
          this.EditpriceError = "Price Field is required";
          return
      }
      else{
          this.EditpriceError = "";
      }
      this.Edit(this.edit);
    },
    DeleteStock(modalId){
      this.modal_id = modalId;
      this.Delete(this.deletestock);
    },
    addProduct(modalId) {
      if (this.data.product == "") {
        this.itemError = "Product is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.quantity == "") {
        this.quantityError = "Quantity Ordered is required";
        return;
      } else {
        this.quantityError = "";
      }
      if (this.data.unit_price == "") {
        this.unit_priceError = "Unit price is required";
        return;
      } else {
        this.unit_priceError = "";
      }
      if (this.existingItem.length) {
        this.itemError = "This Item exists already, edit it instead";
        return;
      } else {
        this.itemError = "";
      }
      this.AddQuotationProduct(this.data);
      this.closeModal(modalId);
      this.resetData();
    },
    closeModal(modalId) {
      this.resetError();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchQuotation(this.id);
    this.FetchItems();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="Quotation">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="quotation-title">
              <!-- <center> -->                
                <div class="row">
                  <div class="col-md-8">
                    <span class="font-size-16">CUSTOMER QUOTATION</span>
                  </div>
                  <div class="col-md-4" align="right">
                    <b-button-group>
                      <b-button class="btn btn-info" v-b-modal.product-modal v-if="BranchData.BranchId != 0 && Quotation && Quotation.status != 2 && MyUserPerm.edit_quotations == 1"><i class="fa fa-plus"></i> Add Product</b-button>                      
                      <b-button
                        variant="success"
                        @click="redirect(Quotation.id)"
                        > Print/Share</b-button
                      >                      
                    </b-button-group>
                    <b-button
                      variant="primary"
                      @click="$router.go(-1)"
                      ><i class="fa fa-arrow-left"></i> Back</b-button
                    >
                  </div>
                </div>
              </div>            
            <hr />
            <div class="row">
              <div class="col-6">
                <address>
                  <strong>Customer:</strong>
                 {{ Quotation.customer }} <br />
                </address>
              </div>
              <div class="col-6">
                <address>
                  <strong>Date:</strong>
                   :{{Quotation.date}} <br />
                   <strong>Quotation Number:</strong>  {{ Quotation.quotation_number }} 
                </address>
              </div>
            
            </div>
            
            <hr />
            <div class="p-2 mt-0">
              <h3 class="font-size-16">Order summary</h3>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 70px">No.</th>
                    <th>Product</th>
                    <th>Quantity</th>
                    <th class="text-sm-end">Price</th>
                    <th class="text-sm-end">Total</th>
                    <th class="text-sm-end" v-if="BranchData.BranchId != 0 && Quotation && Quotation.status != 2">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(pdt, index) in Quotation?Quotation.all:'---'" :key="index">
                    <td>{{ index+1 }}</td>
                    <td>{{pdt.product}}</td>
                    <td>{{pdt.qty}} {{pdt.unit}}</td>
                    <td class="text-sm-end">{{pdt.price.toLocaleString()}}</td>
                    <td class="text-sm-end">{{pdt.total}}</td>
                    <td class="text-sm-end" v-if="BranchData.BranchId != 0 && Quotation && Quotation.status != 2 && MyUserPerm.edit_quotations == 1">
                      <button @click="ShowEdit(pdt)" class="btn btn-info btn-sm" v-b-modal.edit-modal><i class="fa fa-pencil-alt"></i> Edit</button>&nbsp;
                      <button @click="ShowDelete(pdt)" class="btn btn-danger btn-sm" v-b-modal.delete-modal><i class="fa fa-trash"></i> Delete</button>
                    </td>
                  </tr>
                  
                  <tr>
                    <td colspan="4" class="border-0 text-sm-end">
                      <h4>Total</h4>
                    </td>
                    <td class="border-0 text-sm-end">
                      <h4 class="m-0">{{ Quotation.currency+': '+Quotation.total.toLocaleString()}}</h4>
                    </td>
                  </tr>
                </tbody>
              </table>          
            </div>  
            <!-- Product Model -->
            <b-modal id="product-modal" hide-footer @hidden="resetData()">
              <template #modal-title>
                <h4 class="text-warning">Add Product to this Quotation</h4></template
              >
              <div class="form-group mb-3">
                <label>Product <span class="text-danger">*</span></label>
                <model-list-select
                  :list="Products ? Products : []"
                  v-model="data.product"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Product"
                  @input="resetError(),assignArr(), checkItem()"
                >
                </model-list-select>
                <div class="text-danger" v-if="itemError">
                  <em>{{ itemError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Quantity <span class="text-danger">*</span></label>
                <input
                type="number"
                class="form-control"
                step="any"
                v-model="data.quantity"
                @input="resetError()"
                placeholder="Enter Quantity"
                />
                <div class="text-danger" v-if="quantityError">
                <em>{{ quantityError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Unit Measure <span class="text-danger">*</span></label>
                <model-list-select
                :list="unitsArr ? unitsArr : []"
                v-model="data.unit"
                option-value="id"
                option-text="unitsym"
                placeholder="Select Unit"
                @input="resetError(),assignUnitPrices()"
                >
                </model-list-select>
                <div class="text-danger" v-if="unitError">
                <em>{{ unitError }}</em>
                </div>
              </div>  
              <div class="form-group mb-3">
                <label>Unit Price <span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  step="any"
                  id="input3"
                  v-model="data.unit_price"
                  @keyup.enter="addProduct('product-modal')"
                  @input="resetError()"
                  placeholder="Enter Unit Price"
                />
                <div class="text-danger" v-if="unit_priceError">
                  <em>{{ unit_priceError }}</em>
                </div>
              </div>            
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('product-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <b-button
                  @click="addProduct('product-modal')"
                  variant="primary"
                  ><i class="fa fa-plus"></i> Add
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Spinning"
                  ></b-spinner>
                </b-button>
              </div>
            </b-modal>

            <!-- Edit Quotation Item Modal -->
            <b-modal id="edit-modal" hide-footer @hidden="resetEditModal()">
              <template #modal-title>
                <h4 class="text-info">Edit {{ edit.name }}</h4></template
              >
                <label>Quantity: <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    v-model="edit.quantity"
                    placeholder="Quantity"
                    @input="resetError()"
                  />
                </div>
                <div class="text-danger" v-if="EditqtyError">
                  <em>{{ EditqtyError }}</em>
                </div>
              <div class="form-group mb-3">
                <label>Unit Price <span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  step="any"
                  v-model="edit.price"
                  @input="resetError()"
                />
                <div class="text-danger" v-if="EditpriceError">
                  <em>{{ EditpriceError }}</em>
                </div>
              </div> 
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('edit-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button type="button" class="btn btn-warning" @click="EditStock('edit-modal')">
                  <i class="fa fa-pencil-alt"></i> Submit
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Submiting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>

            <!-- Delete Quotation Item Modal -->
            <b-modal id="delete-modal" hide-footer @hidden="resetDeleteModal()">
              <template #modal-title>
                <h4 class="text-danger">Delete {{ deletestock.name }}</h4></template
              >
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button type="button" class="btn btn-danger" @click="DeleteStock('delete-modal')">
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Submiting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal> 
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>